import React, { Fragment, memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Pusher from 'pusher-js';
import { GoogleMap, useJsApiLoader, Marker, OverlayView, DirectionsRenderer, Polyline, Circle } from '@react-google-maps/api';
import { ChevronDown, ChevronRight, MapPin, Truck } from 'react-feather';
import cn from 'classnames';
import { mockData } from './mock';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CardContent,
  Chip,
  Divider,
  Grid,
  Box,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
  CircularProgress,
  ClickAwayListener
} from '@mui/material';
import MainCard from 'components/MainCard';
import { CarOutlined, CompassOutlined, EnvironmentOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { mockVehicle } from './mockVehicle';
// import RealtimeMapGpsService from '@services/realtimeMap'
// import { handleAsyncCall } from '../../utility/Utils'
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import Avatar from 'components/@extended/Avatar';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import { getUserData, handleAsyncCall, toDefaultDateFormat, useLocalStorage } from 'utils/common';
import { realtimeMapService } from 'services/realtimeMap';
import _, { upperCase } from 'lodash';
import useMain from 'hooks/useMain';
import { useSelector } from 'react-redux';
import { rFetchSteps, rFetchWorkflows } from 'store/reducers/comModule';
import { dispatch } from 'store';
import moment from 'moment';
import { setShowDrawer } from 'store/reducers/menu';
import { fetchDistanceMatrix, fetchDistanceService, useRealtimeGpsMap } from './useRealtimeGpsMap';
import { ReactComponent as Flag } from 'assets/images/icons/flag.svg';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { truckImg, startImg, goalImg, gradientCircleImg, historyBrImg } from 'assets/images/icons/mapIcons';
import CarRecordSection from './CarRecordSection';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { sessionConfig } from 'utils/constant';
import { Link } from 'react-router-dom';

const Puller = styled(Box)(({ theme, open }) => ({
  top: 0,
  right: 0,
  width: '50px',
  height: '50px',
  transform: open ? 'rotate(180deg)' : 'rotate(360deg)',
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[0] : theme.palette.grey[900],
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 3,
  position: 'absolute',
  cursor: 'pointer'
}));

// export const andersonLocation = {
//   lat: 22.327668158682787,
//   lng: 114.23281299066622
// };

export const andersonLocation = {
  lat: 22.325988,
  lng: 114.234205
};

const minsFiltering = (d) => {
  if (d.indexOf('mins') > -1) {
    return 'mins';
  }
  if (d.indexOf('min') > -1) {
    return 'min';
  }
  if (d.indexOf('分钟') > -1) {
    return '分钟';
  }
  if (d.indexOf('分鐘') > -1) {
    return '分鐘';
  }
  if (d.indexOf('分') > -1) {
    return '分';
  }
  return '';
};

export const areaPointsNear = (checkPoint, centerPoint, km = 2) => {
  var ky = 40000 / 360;
  var kx = Math.cos((Math.PI * centerPoint.lat) / 180.0) * ky;
  var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
  var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
  return Math.sqrt(dx * dx + dy * dy) <= km;
};

const mapStatusCode = (status) => {
  if (status?.ArrivedSite) {
    return 'ArrivedSite';
  }
  if (status?.ArrivedHK) {
    return 'ArrivedHK';
  }
  if (status?.LeftFactory) {
    return 'LeftFactory';
  }
  return '';
};

const filterVehicleList = (selectedStatus, status) => {
  if (selectedStatus === 'LeftFactory') {
    return status === 'LeftFactory' || status === 'ArrivedHK' || status === 'ArrivedSite' || status === 'SiteAccepted';
  }
  if (selectedStatus === 'ArrivedHK') {
    return status === 'ArrivedHK' || status === 'ArrivedSite' || status === 'SiteAccepted';
  }
  if (selectedStatus === 'ArrivedSite') {
    return status === 'ArrivedSite' || status === 'SiteAccepted';
  }

  return true;
};

const mapStatusToLocation = (status, China, HongKong, upperCaseLang) => {
  switch (status) {
    case 'ArrivedSite':
      return HongKong[1][`LocationName${upperCaseLang}`];
    case 'ArrivedHK':
      return HongKong[0][`LocationName${upperCaseLang}`];

    case 'LeftFactory':
      return China[0][`LocationName${upperCaseLang}`];
    default:
      return '';
  }
};

const RealtimeMapGps = () => {
  const theme = useTheme();

  const mainColor = theme.palette.primary[400];
  const darkMainColor = '#0d244a';
  const lightMainColor = '#6cb4ea';

  const secondaryColor = theme.palette.primary['lighter'];
  const darkColor = theme.palette.primary[900];
  const greyColor = theme.palette.grey['A200'];

  // black dash
  const currentToEndPolylineOptions = {
    strokeColor: '#000000',
    strokeOpacity: 0,
    strokeWeight: 5,
    icons: [
      {
        icon: {
          path: 'M 0,-1 0,1',
          scale: 5,
          fillOpacity: 1,
          fillColor: darkMainColor,
          strokeOpacity: 1,
          strokeColor: darkMainColor,
          strokeWeight: 5
        },
        repeat: '20px'
      }
    ]
  };

  // grenn line
  const startToCurrentPolylineOptions = {
    strokeColor: '#5EC4A2',
    strokeOpacity: 1,
    strokeWeight: 5
  };

  const { setStorage } = useLocalStorage();
  const [zoomAmplifier, setZoomAmplifier] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState('LeftFactory');
  const [showHistory, setShowHistory] = useState(false);

  const { t } = useMain();
  const userData = getUserData();
  useEffect(() => {
    if (userData?.navigate) {
      setStorage(sessionConfig.userData, {
        fullName: userData?.fullName,
        role: userData?.role
      });
    }
  }, [userData?.navigate]);
  const {
    chinaStartToVehicleDirection,
    setChinaStartToVehicleDirection,
    chinaVehicleToEndDirection,
    setChinaVehicleToEndDirection,
    hongKongStartToEndDirection,
    setHongKongStartToEndDirection,
    chinaStartToEndDirection,
    setChinaStartToEndDirection,
    hongKongStartToVehicleDirection,
    setHongKongStartToVehicleDirection,
    hongKongVehicleToEndDirection,
    setHongKongVehicleToEndDirection,

    targetVehicle,
    currentVehicleHistories,
    setCurrentDistrict,
    handleChange,
    mapRef,
    upperCaseLang,
    value,
    setValue,
    openVehicleList,
    setOpenVehicleList,
    mapCenter,
    isLoaded,
    vehicleList,
    workflows,
    currentLocation,
    setCurrentLocation,
    setTargetVehicle,
    count,
    isLoading,
    setCurrentVehicleHistories
  } = useRealtimeGpsMap();

  const ImageRender = ({ src, height, alt, ...rest }) =>
    useMemo(() => <Box component="img" height={`${height * zoomAmplifier}px`} src={src} alt={alt} {...rest} />, [zoomAmplifier]);

  const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -(height / 2)
  });

  const resetValues = () => {
    setTargetVehicle({});
    setCurrentLocation({});
    setCurrentDistrict('');
    setCurrentVehicleHistories([]);
    setChinaVehicleToEndDirection();
    setChinaStartToVehicleDirection();
    setHongKongStartToEndDirection();
    setChinaStartToEndDirection();
    setHongKongStartToVehicleDirection();
    setHongKongVehicleToEndDirection();
  };

  const onClickTargetVehicle = async ({
    BatchNo,
    China,
    HongKong,
    energy,
    CurrentLocation,
    Status,
    LicensePlateNo,
    ProductNo,
    RfidModuleId,
    LastUpdatedTime,
    ...rest
  }) => {
    resetValues();

    // if (_.isEmpty(targetVehicle)) {
    const Geocoder = new window.google.maps.Geocoder();

    const gpsHist = await handleAsyncCall({
      service: realtimeMapService.getTVehicleGpsHistories,
      params: { batchNo: BatchNo, rfidmoduleId: RfidModuleId }
    });
    const devices = await handleAsyncCall({
      service: realtimeMapService.getBatchLocationInterval,
      params: { projId: '629F9E29-0B36-4A9E-A2C4-C28969285583', refid: BatchNo }
    });

    if (!_.isEmpty(devices)) {
      const deviceGps = devices.map(({ GpsHistory }) => GpsHistory).flat();

      const query = _.uniq(deviceGps.map(({ GpsLat, GpsLong }) => `${GpsLat},${GpsLong}`));

      const formattedLocations = query.map((location) => {
        const [lat, lng] = location.split(',');
        return {
          lat: lat,
          lng: lng
        };
      });

      setCurrentVehicleHistories(formattedLocations);
    }

    const leftFactoryDate = gpsHist.Status?.LeftFactory?.UpdatedDate;
    const gpsHistEntries = Object.entries(gpsHist?.Status ?? {});
    const estimatedGpsHist = Object.fromEntries(
      gpsHistEntries.map(([k, v]) => {
        if (k === 'ArrivedHK' && !v && leftFactoryDate) {
          return [
            k,
            {
              LastestStatus: false,
              EstimatedDate: moment(leftFactoryDate).add(2, 'hours').add(11, 'minutes')
            }
          ];
        }
        if (k === 'ArrivedSite' && !v && leftFactoryDate) {
          return [
            k,
            {
              LastestStatus: false,
              EstimatedDate: moment(leftFactoryDate).add(2, 'hours').add(49, 'minutes')
            }
          ];
        }
        return [k, v];
      })
    );

    setTargetVehicle({
      BatchNo,
      energy,
      China,
      HongKong,
      RfidModuleId,
      CurrentLocation,
      Status,
      StatusHist: estimatedGpsHist,
      ...rest
    });
    if (!_.isEmpty(CurrentLocation)) {
      const geo = await Geocoder.geocode({
        location: {
          lat: CurrentLocation?.GpsLat,
          lng: CurrentLocation?.GpsLong
          // lat: 22.548119,
          // lng: 114.072963
        }
      });

      const geoDistrict = geo?.results?.slice(-1)[0]?.formatted_address;

      setCurrentDistrict(geoDistrict);
      setCurrentLocation({
        GpsLat: CurrentLocation?.GpsLat,
        GpsLong: CurrentLocation?.GpsLong,
        TimeStamp: CurrentLocation.TimeStamp

        // lat: 22.548119,
        // lng: 114.072963
      });
    } else {
      setCurrentLocation({});
      setCurrentDistrict('');
    }
    // } else {
    //   setTargetVehicle({});
    // }
  };

  return (
    <>
      {isLoaded && (
        <GoogleMap
          onBoundsChanged={() => {
            if (mapRef.current?.firstChild) {
              const mapHeight = mapRef.current.mapRef?.firstChild.clientHeight;
              const leftPanel = document.getElementById('left-panel');

              if (mapHeight === window.innerHeight) {
                mapRef.current?.mapRef?.firstChild?.appendChild(leftPanel);
              }
            }
          }}
          onZoomChanged={() => {
            // setZoomAmplifier(mapRef.current ? mapRef?.current?.getZoom() / 1.3 / 13 : 1);
            // setCurrentZoom(z)
          }}
          onClick={() => {
            resetValues();
          }}
          ref={mapRef}
          heading={targetVehicle?.BatchNo}
          // // onHeadingChanged={drawRoute}
          mapContainerStyle={{
            position: 'relative',
            height: `calc(100vh - 112px)`,
            margin: '-20px'
          }}
          clickableIcons={false}
          options={{
            fullscreenControl: true,
            disableDefaultUI: true,
            zoomControl: true,
            styles: [
              {
                featureType: 'administrative.country',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'administrative.province',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'water',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              }
            ],
            backgroundColor: 'none'
          }}
          // key={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
          center={mapCenter}
          zoom={10.5}
          // onUnmount={onUnmount}
        >
          {/* {!_.isEmpty(currentVehicleHistories) &&
            currentVehicleHistories.map((history, index) => (
              <OverlayView
                key={`${history?.lat}-${history?.lng}-${index}`}
                position={history}
                mapPaneName={OverlayView.OVERLAY_LAYER}
                getPixelPositionOffset={getPixelPositionOffset}
              >
                <ImageRender height={80} src={historyBrImg} alt="history" />
              </OverlayView>
            ))} */}
          {(_.isEmpty(targetVehicle) ? vehicleList : [targetVehicle])
            .filter(({ CurrentLocation, Status }) => CurrentLocation != null && Status === selectedStatus)
            .map(({ CurrentLocation, BatchNo, RfidModuleId, ...rest }) => (
              <OverlayView
                key={RfidModuleId}
                position={{
                  lat: targetVehicle?.BatchNo === BatchNo ? currentLocation.GpsLat : CurrentLocation?.GpsLat,
                  lng: targetVehicle?.BatchNo === BatchNo ? currentLocation.GpsLong : CurrentLocation?.GpsLong
                  // lat: 22.548119,
                  // lng: 114.072963
                }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={getPixelPositionOffset}
              >
                <ImageRender
                  height={100}
                  src={truckImg}
                  alt="truck"
                  onClick={() => {
                    if (_.isEmpty(targetVehicle)) {
                      onClickTargetVehicle({
                        CurrentLocation,
                        BatchNo,
                        RfidModuleId,
                        ...rest
                      });
                    }
                  }}
                />
              </OverlayView>
            ))}

          {chinaVehicleToEndDirection && (
            <DirectionsRenderer
              options={{
                suppresxsarkers: true,
                polylineOptions: currentToEndPolylineOptions,
                markerOptions: {
                  visible: false
                }
              }}
              directions={chinaVehicleToEndDirection}
            />
          )}
          {hongKongStartToEndDirection && (
            <DirectionsRenderer
              options={{
                suppresxsarkers: true,
                polylineOptions: currentToEndPolylineOptions,
                markerOptions: {
                  visible: false
                }
              }}
              directions={hongKongStartToEndDirection}
            />
          )}
          {chinaStartToVehicleDirection && (
            <DirectionsRenderer
              options={{
                suppresxsarkers: true,
                polylineOptions: startToCurrentPolylineOptions,
                markerOptions: {
                  visible: false
                }
              }}
              directions={chinaStartToVehicleDirection}
            />
          )}
          {chinaStartToEndDirection && (
            <DirectionsRenderer
              options={{
                suppresxsarkers: true,
                polylineOptions: startToCurrentPolylineOptions,
                markerOptions: {
                  visible: false
                }
              }}
              directions={chinaStartToEndDirection}
            />
          )}

          {hongKongStartToVehicleDirection && (
            <DirectionsRenderer
              options={{
                suppresxsarkers: true,
                polylineOptions: startToCurrentPolylineOptions,
                markerOptions: {
                  visible: false
                }
              }}
              directions={hongKongStartToVehicleDirection}
            />
          )}
          {hongKongVehicleToEndDirection && (
            <DirectionsRenderer
              options={{
                suppresxsarkers: true,
                polylineOptions: currentToEndPolylineOptions,
                markerOptions: {
                  visible: false
                }
              }}
              directions={hongKongVehicleToEndDirection}
            />
          )}

          {(chinaStartToEndDirection || hongKongStartToVehicleDirection) && (
            <Polyline
              path={[
                { lat: 22.214786, lng: 113.556989 },
                { lat: 22.209131, lng: 113.588508 },
                { lat: 22.24256, lng: 113.642702 },
                { lat: 22.249837, lng: 113.670266 },
                { lat: 22.261202, lng: 113.68926 },
                { lat: 22.272253, lng: 113.701618 },
                { lat: 22.282327, lng: 113.721946 },
                { lat: 22.283129, lng: 113.83852 },
                { lat: 22.275061, lng: 113.865206 },
                { lat: 22.276755, lng: 113.875659 },
                { lat: 22.292177, lng: 113.899889 },
                { lat: 22.293604, lng: 113.909331 },
                { lat: 22.295163, lng: 113.917038 },
                { lat: 22.291999, lng: 113.930478 }
              ]}
              options={startToCurrentPolylineOptions}
            />
          )}
          {chinaStartToVehicleDirection && (
            <Polyline
              path={[
                { lat: 22.214786, lng: 113.556989 },
                { lat: 22.209131, lng: 113.588508 },
                { lat: 22.24256, lng: 113.642702 },
                { lat: 22.249837, lng: 113.670266 },
                { lat: 22.261202, lng: 113.68926 },
                { lat: 22.272253, lng: 113.701618 },
                { lat: 22.282327, lng: 113.721946 },
                { lat: 22.283129, lng: 113.83852 },
                { lat: 22.275061, lng: 113.865206 },
                { lat: 22.276755, lng: 113.875659 },
                { lat: 22.292177, lng: 113.899889 },
                { lat: 22.293604, lng: 113.909331 },
                { lat: 22.295163, lng: 113.917038 },
                { lat: 22.291999, lng: 113.930478 }
              ]}
              options={currentToEndPolylineOptions}
            />
          )}

          {targetVehicle?.China && (
            <OverlayView
              position={{
                lat: targetVehicle?.China[0]?.lat,
                lng: targetVehicle?.China[0]?.lng
              }}
              mapPaneName={OverlayView.OVERLAY_LAYER}
              getPixelPositionOffset={getPixelPositionOffset}
            >
              <ImageRender height={100} src={startImg} alt="start" />
            </OverlayView>
          )}

          {targetVehicle?.HongKong && (
            <OverlayView
              position={{
                lat: targetVehicle?.HongKong[1]?.lat,
                lng: targetVehicle?.HongKong[1]?.lng
              }}
              mapPaneName={OverlayView.OVERLAY_LAYER}
              getPixelPositionOffset={getPixelPositionOffset}
            >
              <ImageRender height={100} src={goalImg} alt="goal" />
            </OverlayView>
          )}
          <OverlayView position={andersonLocation} mapPaneName={OverlayView.OVERLAY_LAYER} getPixelPositionOffset={getPixelPositionOffset}>
            <ImageRender height={200} src={gradientCircleImg} alt="gradient-circle" />
          </OverlayView>
          <Box
            id="left-panel"
            sx={{
              position: 'absolute',
              borderRadius: '12px',
              bottom: '100px',
              left: '20px',
              top: '20px',
              right: '20px',
              height: openVehicleList ? '80vh' : '15vh',
              width: ['83vw', '400px'],
              overflowY: 'scroll',
              '::-webkit-scrollbar': {
                display: 'none'
              },
              bgcolor: 'white'
            }}
          >
            <Box position="relative" p="22px">
              <Puller
                role="button"
                theme={theme}
                open={openVehicleList}
                onClick={() => {
                  setOpenVehicleList(!openVehicleList);
                }}
              >
                <ChevronDown />
              </Puller>
              <Typography variant="h5" color={mainColor} mb="12px">
                {t('FLEET_PROCESS')}
              </Typography>

              <Box borderRadius="14px" mb={2} border={`1px solid ${greyColor}`} height={'106px'}>
                <Grid
                  container
                  height="100%"
                  sx={{
                    '& > div:first-of-type ': {
                      borderRight: `1px solid ${greyColor}`,
                      '& > div': {
                        borderTopLeftRadius: '10px'
                      }
                    },
                    '& > div:last-of-type': {
                      borderLeft: `1px solid ${greyColor}`,

                      '& > div': {
                        borderTopRightRadius: '10px'
                      }
                    }
                  }}
                >
                  {[
                    { label: 'LeftFactory', value: count?.LeftFactory ?? 0 },
                    { label: 'ArrivedHK', value: count?.ArrivedHK ?? 0 },
                    { label: 'ArrivedSite', value: count?.ArrivedSite ?? 0 }
                  ].map(({ label, value }, i) => (
                    <Grid
                      key={`${label}`}
                      item
                      xs={4}
                      role="button"
                      sx={{
                        border: selectedStatus === label ? `2px solid ${mainColor} !important` : 'initial',
                        flexDirection: 'column',
                        borderTopLeftRadius: i === 0 ? '12px' : 0,
                        borderBottomLeftRadius: i === 0 ? '12px' : 0,
                        borderTopRightRadius: i === 2 ? '12px' : 0,
                        borderBottomRightRadius: i === 2 ? '12px' : 0
                      }}
                      onClick={() => {
                        // if (selectedStatus === label) {
                        //   return setSelectedStatus('');
                        // }
                        resetValues();
                        setSelectedStatus(label);
                      }}
                    >
                      {' '}
                      <Box
                        height="40%"
                        bgcolor={mainColor}
                        alignItems="center"
                        justifyContent="center"
                        display="flex"
                        borderBottom={`1px solid ${greyColor}`}
                      >
                        <Typography variant="h5" color="white">
                          {t(label.toUpperCase())}
                        </Typography>
                      </Box>
                      <Box height="60%" alignItems="center" justifyContent="center" display="flex">
                        <Typography variant="h2">{value}</Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Stack rowGap={1}>
                {isLoading ? (
                  <Box alignItems="center" justifyContent="center" width="100%" height="100%">
                    <CircularProgress />
                  </Box>
                ) : showHistory ? (
                  <Grid container height="100%" sx={{}}></Grid>
                ) : (
                  vehicleList
                    .filter(({ Status }) => Status === selectedStatus)
                    .sort((a, b) => {
                      if (a.CurrentLocation?.GpsLat === 0 && b.CurrentLocation?.GpsLat !== 0) {
                        return 1;
                      }
                      if (a.CurrentLocation?.GpsLat !== 0 && b.CurrentLocation?.GpsLat === 0) {
                        return -1;
                      }
                      if (b.CurrentLocation?.GpsLat === 0 && a.CurrentLocation?.GpsLat === 0) {
                        return 0;
                      }

                      return b.LastUpdatedTime - a.LastUpdatedTime;
                    })
                    .map(
                      (
                        {
                          BatchNo,
                          China,
                          HongKong,
                          energy,
                          CurrentLocation,
                          Status,
                          LicensePlateNo,
                          ProductNo,
                          RfidModuleId,
                          LastUpdatedTime,
                          ...rest
                        },
                        index
                      ) => {
                        // const targetWorkflowStatus = workflows?.find(({ Wfcode }) => Wfcode === Status);

                        const isTargetVehicle = !_.isEmpty(targetVehicle) && RfidModuleId === targetVehicle?.RfidModuleId;
                        // const isTargetVehicle = false;
                        let timeStamp = '';
                        let status = Status;
                        let targetCurrentLocation = CurrentLocation;
                        if (isTargetVehicle) {
                          status = targetVehicle?.Status;
                          targetCurrentLocation = currentLocation;

                          if (status === 'ArrivedSite') {
                            timeStamp = moment(targetCurrentLocation?.TimeStamp, 'YYYY-MM-DDTHH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
                          }
                        }
                        timeStamp = moment(targetCurrentLocation?.TimeStamp, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
                          // .add(8, 'hours')
                          .format('YYYY/MM/DD HH:mm:ss');

                        const geoAddress = isTargetVehicle
                          ? targetVehicle?.distanceAndDuration?.geoAddress
                          : rest?.distanceAndDuration?.geoAddress;

                        const geoDistrict = isTargetVehicle
                          ? targetVehicle?.distanceAndDuration?.geoDistrict
                          : rest?.distanceAndDuration?.geoDistrict;

                        const distance = isTargetVehicle
                          ? targetVehicle?.distanceAndDuration?.distance
                          : rest?.distanceAndDuration?.distance;
                        const duration = isTargetVehicle
                          ? targetVehicle?.distanceAndDuration?.duration
                          : rest?.distanceAndDuration?.duration;

                        return (
                          <MainCard
                            key={`google-map-vehicle-detail-${index}`}
                            sx={{
                              overflow: 'initial',
                              borderRadius: '14px',
                              border: isTargetVehicle ? `3px solid ${mainColor} !important` : '1px solid #f5f5f5'
                            }}
                            contentSX={{
                              px: '6px',
                              py: '12px',
                              ':last-child': {
                                paddingBottom: 0
                              }
                            }}
                            role="button"
                            onClick={async () => {
                              onClickTargetVehicle({
                                BatchNo,
                                China,
                                HongKong,
                                energy,
                                CurrentLocation,
                                Status,
                                LicensePlateNo,
                                ProductNo,
                                RfidModuleId,
                                LastUpdatedTime,
                                ...rest
                              });
                            }}
                            //   className={cn(value === index && 'border border-warning', 'mb-0 cursor-pointer')}
                          >
                            <Accordion
                              expanded={isTargetVehicle}
                              sx={{
                                boxShadow: 'none',
                                '.MuiAccordionSummary-expandIconWrapper': {
                                  '> svg': {
                                    fill: mainColor
                                  },
                                  height: 'fit-content'
                                },
                                '.MuiAccordionSummary-content': {
                                  margin: 0
                                }
                              }}
                            >
                              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                <Box borderBottom={`1px solid #f5f5f5`} width="100%">
                                  <Stack mb={1} px="8px" justifyContent="space-between" flexDirection="row">
                                    <Typography borderLeft={`3px solid ${mainColor}`} pl={1} variant="h5">
                                      {BatchNo}
                                    </Typography>

                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      columnGap={1}
                                      bgcolor={secondaryColor}
                                      sx={{
                                        borderRadius: '11px',
                                        px: '8px',
                                        mr: '-30px'
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          borderRadius: '50%',
                                          height: '8px',
                                          width: '8px',
                                          bgcolor: mainColor
                                        }}
                                      />{' '}
                                      <Typography color={mainColor} variant="body2">
                                        {t(Status.toUpperCase())}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                  <Typography variant="h6" pl={2}>
                                    {LicensePlateNo}
                                  </Typography>
                                  <Typography variant="h6" pl={2}>
                                    {ProductNo}
                                  </Typography>
                                  <Stack px={2} mt={1}>
                                    <Grid container columnGap={1}>
                                      <Grid item xs={1} justifyContent="center" alignItems="center">
                                        <Flag />
                                      </Grid>
                                      <Grid item xs={10} ml="4px">
                                        <Typography>{geoAddress || t('NO_DATA')}</Typography>
                                      </Grid>

                                      <Grid item xs={1}>
                                        <Box
                                          sx={{
                                            path: {
                                              fill: darkColor
                                            }
                                          }}
                                        >
                                          <Flag />
                                        </Box>
                                      </Grid>
                                      <Grid item xs={10} ml="4px">
                                        <Typography> {HongKong[1][`LocationName${upperCaseLang}`]}</Typography>
                                      </Grid>

                                      {targetCurrentLocation?.GpsLat > 0 && (
                                        <>
                                          {' '}
                                          <Grid item xs={5}>
                                            <Stack alignItems="flex-start">
                                              <Typography color={greyColor}>{t('ESTIMATE_TIME')}</Typography>
                                              {
                                                <Typography fontWeight="bold">
                                                  {duration
                                                    ? `${Number(duration?.replace(minsFiltering(duration), '')).toFixed(
                                                        0
                                                      )} 分 (${distance})`
                                                    : `-`}
                                                </Typography>
                                              }
                                            </Stack>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Stack alignItems="flex-end" mr="-50px">
                                              <Typography color={greyColor}>{t('LAST_UPDATE_TIME')}</Typography>
                                              <Typography textAlign="end">{timeStamp}</Typography>
                                            </Stack>
                                          </Grid>{' '}
                                        </>
                                      )}
                                    </Grid>
                                  </Stack>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails sx={{ p: 0 }}>
                                <Stack px="16px" py="12px">
                                  <Typography color={greyColor} mb={'12px'}>
                                    行車記錄
                                  </Typography>
                                  {!_.isEmpty(targetVehicle?.StatusHist) &&
                                    Object.entries(targetVehicle?.StatusHist).map(([k, v], i) => (
                                      <CarRecordSection
                                        key={k}
                                        time={v?.UpdatedDate ? moment(v.UpdatedDate) : null}
                                        status={t(k.toUpperCase())}
                                        arrived={!!v?.UpdatedDate}
                                        lineStyles={{
                                          borderRight:
                                            targetVehicle?.StatusHist[k]?.LastestStatus || targetVehicle?.StatusHist[k]?.EstimatedDate
                                              ? `1px dashed ${greyColor}`
                                              : '1px solid black',
                                          display: i == 2 ? 'none' : 'block'
                                        }}
                                        location={mapStatusToLocation(k, China, HongKong, upperCaseLang)}
                                      />
                                    ))}
                                </Stack>
                              </AccordionDetails>
                            </Accordion>
                          </MainCard>
                        );
                      }
                    )
                )}
              </Stack>
            </Box>
            {/* <Typography
              component={Button}
              onClick={() => {
                setShowHistory((prev) => !prev);
              }}
              sx={{ textDecoration: 'underline', color: 'grey', cursor: 'pointer', position: 'absolute', bottom: '12px', right: '20px' }}
            >
              {t(showHistory ? 'REALTIME_MAP' : 'HISTORY_RECORD')}
            </Typography> */}
          </Box>
        </GoogleMap>
      )}
    </>
  );
};

export default RealtimeMapGps;
